declare namespace $ {

	export class $lim_rtest2_button extends $mol_button_major {
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map